


















































































































































import Vue from 'vue';
import layout from '@/libs/layout/educational/course';
import { Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import {
  TCoursePage,
  PCourseSearch,
  TMaterialList
} from '@/types/views/educational';
import { getCourseList, getTeachers, getAllMaterial } from '@/api/educational';
import { TLayout } from '@/types/utils';
import { getTeacherList } from '@/api/school';
import { getOrgList } from '@/api/school';
import { TOrgList } from '@/types/views/school'
const namespace = 'user';
interface TSearchClassForm {
  teacherName: string;
  className: string; // 班级名称
  teacherId: string; // 主讲老师id
  teachingMaterialId: string; // 教材id
  classDate: string; // 频率
  orgId: string; // 校区ID
}

@Component({
  components: {
    AddClass: () => import('./modules/class-detail/add-class.vue')
  }
})
export default class Course extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  private query = '';
  private courseInfo: TMaterialList = {};
  private activeName = '';
  private materialList: any[] = [];
  private teachers: any = {};
  private layout: TLayout = layout;
  private page: TCoursePage = {
    currentPage: 1,
    pageSize: 20
  };
  private searchOption: PCourseSearch = {
    currentPage: 1,
    pageSize: 20
  };
  private form: TSearchClassForm = {
    teacherName: '',
    className: '',
    teacherId: '',
    teachingMaterialId: '',
    classDate: '',
    orgId: ''
  };
  // add by_ALi
  private orgList = []
  /**
   * 获取校区列表
   * @param {TOrgList} params
   */
  private async getOrgList(params: TOrgList) {
      try {
          let res: any = await getOrgList(params);
          console.log(res)
          this.orgList = res;
      } catch (e) {
          this.$message.error(e);
      }
  }

  // 上课时间
  private getClassTime(date: Date) {
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return `${hour}:${minute}`;
  }

  private getClassStartTime(date: any) {
    console.log(JSON.parse(date));
    return JSON.parse(date);
  }
  private activated() {
    this.getCourseList();
    this.getAllMaterial();
    this.getTeachers();
    this.getOrgList({orgId: ''});
  }
  private handleSize(size: number) {
    this.searchOption = {
      ...this.searchOption,
      ...{ courseName: this.query, pageSize: size }
    };
    this.getCourseList();
  }
  private getStatusType(status: string) {
    let arr: any = { CO: 'danger', ON: 'success', NO: 'info' };
    return arr[status];
  }
  /**
   * 获取教材列表
   */
  private async getAllMaterial() {
    try {
      let res: any = await getAllMaterial({ orgId: this.orgId });
      if (res.code === '000001') {
        this.materialList = res.data;
      }
    } catch (e) {
      this.$message.error(e);
    }
  }
  /**
   * 获取老师列表
   */
  private async getTeachers() {
    try {
      this.teachers = await getTeachers();
      console.log("----")
      console.log(this.teachers)
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  // 新建班级
  private addNewClass() {
    (this.$refs.dialog as any).dialogVisible = true;
  }

  private handlePage(page: number) {
    this.searchOption = {
      ...this.searchOption,
      ...{
        currentPage: page,
        pageSize: this.page.pageSize,
        courseName: this.query
      }
    };
    this.getCourseList();
  }
  private renderIndex(index: number) {
    return index + 1 + (this.page.currentPage - 1) * this.page.pageSize || 0;
  }
  private goToCourseDetail(id: number) {
    this.$router.push({
      path: `/educational/course-detail/${id}`
    });
  }
  private search() {
    this.searchOption = {
      ...this.searchOption,
      ...{ pageSize: this.page.pageSize, courseName: this.query }
    };
    this.getCourseList();
  }
  private reset() {
    this.form = {
      teacherName: '',
      className: '',
      teacherId: '',
      teachingMaterialId: '',
      classDate: '',
      orgId: ''
    };
  }
  private searchFilter() {
    this.searchOption = {
      ...this.form,
      ...{ currentPage: 1, pageSize: this.page.pageSize }
    };
    this.getCourseList();
  }
  private handleClick(tab: any, event: any) {
    this.searchOption = {
      ...{ status: tab.name, currentPage: 1, pageSize: this.page.pageSize }
    };
    this.reset();
    this.getCourseList();
  }
  private async getCourseList() {
    try {
      this.page = await getCourseList(this.searchOption);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
